import Analytics from '@withlocals/withlocals-analytics';
import RoundedButton from 'components/RoundedButton';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useHistory, useLocation } from 'react-router-dom';
import basePath from 'utils/basePath';

const CSS = require('./ServerError.less');

function ServerErrorInternal() {
  const location = useLocation();
  const history = useHistory();

  const getErrorFromQueryString = () => {
    const params = new URLSearchParams(location.search);
    return {
      status: params.get('statusCode') || '500',
      message: params.get('message'),
    };
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const status = params.get('statusCode') || '500';
    Analytics.track(status, location.pathname, window.document.referrer);
    window.scrollTo(0, 0);
  }, [location]);

  const goHome = () => {
    history.push('/');
  };

  const params = getErrorFromQueryString();

  return (
    <div className={CSS.ServerErrorContainer}>
      <Helmet>
        <meta name="render:status_code" content={params.status} />
      </Helmet>
      <div className={CSS.ServerErrorHeader}>
        <h1 className={CSS.ServerErrorTitle}>
          Internal server error {params.status}
        </h1>
        <p>Server returned an error message: '{params.message}'</p>
      </div>
      <div className={CSS.ServerErrorSubtitleContainer}>
        <RoundedButton
          onClick={goHome}
          className={CSS.ServerErrorSubtitle}
          inverted
        >
          Find your destination
        </RoundedButton>
      </div>
    </div>
  );
}

export default [
  <NavigationableLayout
    key="server-error"
    path={`${basePath}/error/`}
    component={ServerErrorInternal}
    showSearchInNavbar
    nonFixedNavbar
  />,
];
